import { useRef, useState } from 'react';
import { useReducedMotion } from 'framer-motion';

/**
 * Subtle perspective tilt on pointer move — gives a light 3D feel without WebGL.
 */
export default function TiltCard({ children, className = '', maxTilt = 7, as: Tag = 'div' }) {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const [style, setStyle] = useState({
    transform: 'perspective(900px) rotateX(0deg) rotateY(0deg) scale(1)',
  });

  const onMove = (e) => {
    if (reduce || !ref.current) return;
    // Skip continuous tilt on coarse touch — TouchHover handles lift instead
    if (e.pointerType === 'touch') return;
    const rect = ref.current.getBoundingClientRect();
    const px = (e.clientX - rect.left) / rect.width;
    const py = (e.clientY - rect.top) / rect.height;
    const rotateY = (px - 0.5) * (maxTilt * 2);
    const rotateX = (0.5 - py) * (maxTilt * 2);
    setStyle({
      transform: `perspective(900px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.02)`,
      transition: 'transform 0.08s ease-out',
    });
  };

  const onLeave = () => {
    setStyle({
      transform: 'perspective(900px) rotateX(0deg) rotateY(0deg) scale(1)',
      transition: 'transform 0.45s ease',
    });
  };

  const onTouchLift = () => {
    if (reduce) return;
    setStyle({
      transform: 'perspective(900px) rotateX(2deg) rotateY(0deg) translateY(-6px) scale(1.02)',
      transition: 'transform 0.25s ease',
    });
  };

  return (
    <Tag
      ref={ref}
      className={`tilt-card ${className}`.trim()}
      style={style}
      onPointerMove={onMove}
      onPointerLeave={onLeave}
      onPointerDown={(e) => {
        if (e.pointerType === 'touch') onTouchLift();
      }}
      onPointerUp={(e) => {
        if (e.pointerType === 'touch') onLeave();
      }}
      onPointerCancel={onLeave}
    >
      {children}
    </Tag>
  );
}
